import { Box, Typography, Button, styled } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import theme from 'src/utils/themeManagementVersion2'
import { useRouter } from 'next/router'
import { managementRegistrationState } from 'src/recoil/management'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import handleError from 'src/utils/handleError'
import * as ManagementCompanyApis from 'src/apis/management/company'
import RegistrationTitle from './RegistrationTitle'
import { useState } from 'react'

type Props = {
  onBack: () => void
}

const SubTitleBox = styled(Box)({
  padding: '16px',
  textAlign: 'center',
})

const SubTitleText = styled(Typography)({
  lineHeight: '32px',
  fontSize: '24px',
  fontWeight: 600,
  color: theme.palette.text.primary,
})

const ContentBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
})

const ContentText = styled(Typography)({
  lineHeight: '24px',
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.text.primary,
})

const ButtonBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '16px',
  marginTop: '16px',
})

const ActionButton = styled(Button)({
  width: '200px',
  lineHeight: '26px',
})

const ManagementRegistrationConfirmation = ({ onBack }: Props) => {
  const router = useRouter()
  const managementRegistration = useRecoilValue(managementRegistrationState)
  const resetManagementRegistration = useResetRecoilState(managementRegistrationState)
  const [isSending, setIsSending] = useState(false)

  const handleBack = () => {
    onBack()
  }

  const handleConfirm = async () => {
    setIsSending(true)

    try {
      const formData = {
        company: {
          name: managementRegistration.companyName,
          applicantAttributes: {
            name: managementRegistration.name,
            email: managementRegistration.email,
          },
        },
      }
      await ManagementCompanyApis.create(formData)
      resetManagementRegistration()
      router.push('/management/registration-finished')
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Box className='content-center' sx={{ backgroundColor: 'transparent' }}>
        <Box sx={{ maxWidth: '568px', width: '100%' }}>
          <Box sx={{ textAlign: 'center' }}>
            <RegistrationTitle />
          </Box>
          <SubTitleBox>
            <SubTitleText>無料トライアル 新規申し込み</SubTitleText>
          </SubTitleBox>
          <ContentBox p={2} sx={{ textAlign: 'center' }}>
            <ContentText>以下の内容でサービス申し込みを行います。</ContentText>
            <Box>
              <ContentText>会社名</ContentText>
              <ContentText>{managementRegistration.companyName}</ContentText>
            </Box>
            <Box>
              <ContentText>氏名</ContentText>
              <ContentText>{managementRegistration.name}</ContentText>
            </Box>
            <Box>
              <ContentText>メールアドレス</ContentText>
              <ContentText>{managementRegistration.email}</ContentText>
            </Box>
          </ContentBox>
          <ButtonBox>
            <ActionButton fullWidth size='large' variant='outlined' onClick={handleBack}>
              修正
            </ActionButton>
            <ActionButton
              fullWidth
              size='large'
              variant='contained'
              type='submit'
              sx={{ color: theme.palette.primary.contrast }}
              onClick={handleConfirm}
              disabled={isSending}
            >
              申し込み
            </ActionButton>
          </ButtonBox>
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default ManagementRegistrationConfirmation
